import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationLocation($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          plainAddress: attribute(key: "basic_information/address") {
            plainAddress {
              value
              details
            }
          }
          location: attribute(key: "basic_information/location") {
            location {
              latitude
              longitude
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
